import { CartPill } from 'components/CartPill/CartPill';
import { mainPostAListingRoute } from 'modules/main/main.routes';
import { useUserEnvironmentCartPillOrgsData } from 'modules/main/store/hooks/useUserEnvironmentCartPillOrgsData';
import { useABExperimentOrgDashboardCartRoute } from 'modules/orgDashboard/hooks/useABExperimentOrgDashboardCartRoute';

export function CartPillContainer() {
  const { orgsCartData } = useUserEnvironmentCartPillOrgsData();
  const orgDashboardCartRoute = useABExperimentOrgDashboardCartRoute();

  const userHasAtLeastOneOrg = Boolean(orgsCartData?.length);
  if (!userHasAtLeastOneOrg) return null;

  return (
    <CartPill
      selectedOrgId={undefined}
      getOrgCartDataHref={(orgCartData) =>
        orgDashboardCartRoute.with({ orgId: orgCartData.id })
      }
      orgsCartData={orgsCartData || []}
      emptyHrefs={{
        postAJob: mainPostAListingRoute.with({ listingType: 'JOB' }),
        postAnInternship: mainPostAListingRoute.with({
          listingType: 'INTERNSHIP',
        }),
        postAVolop: mainPostAListingRoute.with({ listingType: 'VOLOP' }),
      }}
    />
  );
}
